import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'shared/lib';

import { getRemainingSeconds, tick } from 'entities/scenario';

export const useStartTimerTick = () => {
  const dispatch = useAppDispatch();
  const remaining = useAppSelector(getRemainingSeconds);

  useEffect(() => {
    if (remaining <= 0) {
      return;
    }

    const id = setInterval(() => {
      if (remaining <= 0) {
        clearInterval(id);
        return;
      }
      dispatch(tick());
    }, 1_000);

    return () => clearInterval(id);
  }, [dispatch, remaining]);
};
